module.exports = __webpack_public_path__ + "c07afd479acfce7536bfaae9e228f2c8.pdf";